// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__juMUx","overflowVisible":"style_overflowVisible__g6iys","noPadding":"style_noPadding__tGa9N","padding25":"style_padding25__iHo2y"};